

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import BrandLogo from "./BrandLogo";
import NavMenu from "./NavMenu";
import NotificationDropdown from "./NotificationDropdown";
import UserDropdown from "./UserDropdown";
import { useDispatch, useSelector } from "react-redux";
import { uiAction } from "../../../../Redux/Slices/uiSlice";
import { fetchProfileDetails } from "../../../../Redux/Slices/OrgProfileSlice";
const EcomHeader = () => {
    const [toggle, setToggle] = React.useState(true);
    const navigate = useNavigate();
    const projectType = useSelector((state) => state.uiReducers.appType) || "Business";
    const dispatch = useDispatch();
    const handleLogout = () => {
        sessionStorage.removeItem("loggedInUser");
        sessionStorage.removeItem("Apptype");
        navigate("/login", { replace: true });
        dispatch(uiAction.updateAppType("Business"));
    };
    const handleToggle = async (e) => {
        setToggle((toggle) => !toggle);
        e.preventDefault();
        const newMode = projectType === "Ecommerce" ? "Business" : "Ecommerce";
        const result = await Swal.fire({
            title: `Switch to ${newMode} Mode?`,
            text: "This will change the layout and features of the application.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, switch it!",
            cancelButtonColor: "red",
            confirmButtonColor: "green"
        });
        if (result.isConfirmed) {
            sessionStorage.setItem("Apptype", newMode);
            dispatch(uiAction.updateAppType(newMode));
            setToggle((toggle) => !toggle);
            navigate("/dashboard", { replace: true });// Redirect to home or any other page
        }
        if (result.isDismissed) {
            setToggle((toggle) => !toggle);
        }
    };
    useEffect(() => {
        dispatch(fetchProfileDetails())
    }, [])
    return (
        <nav style={{ background: "#5d143f", zIndex: "99" }} className="navbar bg-org navbar-top navbar-slim justify-content-between fixed-top navbar-expand-lg  bg-org" id="navbarTopSlim" data-navbar-appearance="darker">
            <div className="test-mode"><span>Test Mode</span></div>
            <BrandLogo />
            <div className="form-check form-switch text-white">
                <span className="ms-2 fw-semibold text-white">{projectType !== "Ecommerce" ? "Property Dashboard" : "Ecommerce"}</span>
                <input checked={toggle} onChange={handleToggle} className="form-check-input" type="checkbox" id="themeToggle" />
            </div>
            <div className="navbar-collapse navbar-top-collapse order-1 order-lg-0 justify-content-center">
                <NavMenu />
            </div>
            <NotificationDropdown />
            <UserDropdown onLogout={handleLogout} />

        </nav>
    );
};

export default EcomHeader;


